import { useCallback } from 'react'
import {
	type EventType,
	getEventTypesListEventTypesQueryKey,
	getMeProfileGetMeProfileQueryKey,
	useEventTypesDeleteEventType,
} from '@cocoonspace/api'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@cocoonspace/ui/components/alert-dialog'
import { Trans, useLingui } from '@lingui/react/macro'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2Icon } from 'lucide-react'
import { toast } from 'sonner'

import { ScheduleCardActionBtn } from '../../scheduling-card'

export const DeleteAction = ({ eventType }: { eventType: EventType }) => {
	const queryClient = useQueryClient()
	const { t } = useLingui()

	const deleteEventTypeMutation = useEventTypesDeleteEventType()

	const deleteEventType = useCallback(() => {
		return deleteEventTypeMutation
			.mutateAsync({ id: eventType.id })
			.then(() => {
				toast.success(t`Type de rendez-vous mis à jour`)

				queryClient.invalidateQueries({
					queryKey: getEventTypesListEventTypesQueryKey(),
				})

				queryClient.invalidateQueries({
					queryKey: getMeProfileGetMeProfileQueryKey(),
				})
			})
			.catch(() => {
				toast.error(t`Erreur lors de la mise à jour du type de rendez-vous`)
			})
	}, [deleteEventTypeMutation, eventType.id, t, queryClient])

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<ScheduleCardActionBtn title={t`Supprimer`}>
					<Trash2Icon />
				</ScheduleCardActionBtn>
			</AlertDialogTrigger>

			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>
						{t`Supprimer le type de rendez-vous`}
					</AlertDialogTitle>
				</AlertDialogHeader>

				<AlertDialogDescription>
					<Trans>
						Etes-vous sûr de vouloir supprimer{' '}
						<strong>{eventType.title}</strong> ?
					</Trans>
				</AlertDialogDescription>

				<AlertDialogFooter>
					<AlertDialogCancel>{t`Annuler`}</AlertDialogCancel>

					<AlertDialogAction onClick={() => deleteEventType()}>
						{t`Supprimer`}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
